import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Table,
  TableBody,
  TableHeader,
  TableRow,
  Td,
  Th,
  Link,
} from "@graffer-inc/console-design-kit";

import { displayName } from "../../../application/domain/rbac/rbac";
import { ServiceAccount } from "../../../application/domain/service-account/service-account";

export type ServiceAccountWithDetailPageLink = ServiceAccount & {
  detailPageLink: string;
};

type Props = {
  serviceAccounts: ServiceAccountWithDetailPageLink[];
};

export const ServiceAccountsListTable: React.FC<Props> = ({
  serviceAccounts,
}) => {
  return (
    <Table borderType="row">
      <TableHeader>
        <Th>ID</Th>
        <Th>アカウント名</Th>
        <Th>ロール</Th>
        <Th>アカウントステータス</Th>
      </TableHeader>
      <TableBody>
        {serviceAccounts.map(
          ({ id, accountName, roles, disabled, detailPageLink }) => {
            return (
              <TableRow key={id}>
                <Td>
                  <Link
                    anchor={({ ...props }) => (
                      <RouterLink {...props} to={detailPageLink} />
                    )}
                  >
                    <span>{id}</span>
                  </Link>
                </Td>
                <Td>{accountName}</Td>
                <Td>
                  {roles.map((role) => (
                    <p key={role}>{displayName(role)}</p>
                  ))}
                </Td>
                <Td>{disabled ? "無効" : "有効"}</Td>
              </TableRow>
            );
          },
        )}
      </TableBody>
    </Table>
  );
};
